module.exports = __webpack_public_path__ + "img/goods5_3.fd4aebdb.jpg";